/**
 * @generated SignedSource<<b0df710506daef4b3481cb8e7dda6aad>>
 * @relayHash 030c1ac826a6e18918480515e939dc82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50172a9df428a3b05684f86efd046ee5c808b1f16e534a98efe54423526b446c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "50172a9df428a3b05684f86efd046ee5c808b1f16e534a98efe54423526b446c",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
